import DistEvents from '@gameday/core/events/DistEvents';
import MessageService from 'message-service/message-service';
import { replaceRouteAction } from 'bdata-react-component/lib/router/DataRouter';
const { PAUSE_HEARTBEAT, START_HEARTBEAT, SWITCH_EXTERNAL, SWITCH_INTERNAL } = DistEvents;

export const CHANGE_VIEW = 'CHANGE_VIEW';

const changeView = (data) => (dispatch, getState) => {
    const state = getState();
    const {
        views,
        config: {
            language = 'en',
            locale = 'en-US'
        }
    } = state;

    const {
        timecode,
        gamePk,
        fieldVisionOn
    } = views;

    const {
        game_view,
        game_tab,
        detail,
        next_game_state,
        prev_game_state = next_game_state,
        game_updated
    } = data;

    const urlparams = {};
    let updateRoute = data.updateRoute;
    // Called for chaning the game view (preview/live/final)
    if (typeof game_view !== 'undefined') {
        urlparams.game_view = game_view;
        urlparams.game_tab = '';
        urlparams.detail = '';
        updateRoute = true; // compare with existing before updating
    }
    // Called for changing the tab in the game view (summary/box)
    if (typeof game_tab !== 'undefined') {
        urlparams.game_tab = game_tab;
        updateRoute = true;
    }
    // Called for changing the detail view (plays 2)
    if (typeof detail !== 'undefined') {
        urlparams.detail = detail;
        updateRoute = true;
    }
    // Called after a data engine update
    if (!game_updated && prev_game_state !== next_game_state) {
        // If the game didn't change, but the state did, only auto-forward if not live
        if (prev_game_state !== 'Live') {
            urlparams.game_view = next_game_state.toLowerCase();
            urlparams.game_tab = '';
            urlparams.detail = '';
            updateRoute = true;
        } else {
            urlparams.game_view = 'live';
        }
        // If the game did update, update the route to show the gamepk
    } else if (game_updated) {
        urlparams.game_view = '';
        urlparams.game_tab = '';
        urlparams.detail = '';
        updateRoute = true;
    }

    const viewChange = {
        ...views,
        timecode: data?.timecode ? data.timecode : timecode, // for testing game states
        gamePk: data?.gamePk ? data.gamePk : gamePk,
        locale,
        language,
        fieldVisionOn: data?.fieldVisionOn ?? fieldVisionOn,
        ...urlparams
    };

    // Only dispatch if there is new info to show
    let shouldDispatch = false;
    for (const [key, value] of Object.entries(viewChange)) {
        if (views[key] !== value) {
            shouldDispatch = true;
            break;
        }
    }

    if (viewChange.fieldVisionOn !== fieldVisionOn) {
        if (viewChange.fieldVisionOn) {
            MessageService.publish(SWITCH_EXTERNAL);
        } else {
            MessageService.publish(SWITCH_INTERNAL);
        }
    } else if (game_updated && viewChange.fieldVisionOn) {
        MessageService.publish(SWITCH_EXTERNAL);
    }

    if (shouldDispatch) {
        dispatch({
            type: CHANGE_VIEW,
            viewtype: viewChange
        });
    }

    // Only update the route if necessary
    if (updateRoute) {
        dispatch(replaceRouteAction(viewChange));
    }
};

export default changeView;
